import type { HTTPService } from "@soft-db/http";
import type { SetOptional } from "type-fest";
import type { UserScope } from "./user-api";

export type UserRecipients = {
	id: string;
	user: string;
	details: {
		name: string;
		avatar: string;
	};
};
export type ExternalRecipients = {
	id: string;
	externalRecipient: string;
	details: {
		name: string;
		notes: string;
		email: string;
		phoneNumber: string;
	};
};

export type AnyRecipient = UserRecipients | ExternalRecipients;

export type Recipients = RecipientUpdate[];

export type RecipientUpdateType = "user" | "phone-number" | "email";

export type RecipientUpdate = {
	type: RecipientUpdateType;
	scope: UserScope;
	value: string;
};

export type BatchRecipientsUpdate = {
	add: RecipientUpdate[];
	remove: RecipientUpdate[];
};

export type RecipientType = "user" | "external";
export type RecipientSchema = {
	recipienType: RecipientType;
	recipientId: string;
	enabled: boolean;
	notifyEmail: boolean;
	notifySMS: boolean;
};

export type CreateRecipient = SetOptional<RecipientSchema, "enabled" | "notifyEmail" | "notifySMS">;
export type UpdateRecipient = Partial<
	Pick<RecipientSchema, "enabled" | "notifyEmail" | "notifySMS">
>;

export type RecipientResourceType = "station" | "site" | "alert" | "report";

export type ResourceIdentity = {
	type: RecipientResourceType;
	id: string;
};

export class RecipientsApi {
	#http: HTTPService;

	constructor(http: HTTPService) {
		this.#http = http;
	}

	async currentUserSubscribe(resource: ResourceIdentity) {
		const resourcePlural = resource.type + "s";
		return await this.#http.post<AnyRecipient>(
			`${resourcePlural}/${resource.id}/recipients/users/me`
		);
	}

	async currentUserUnsubscribe(resource: ResourceIdentity) {
		const resourcePlural = resource.type + "s";
		return await this.#http.delete<AnyRecipient>(
			`${resourcePlural}/${resource.id}/recipients/users/me`
		);
	}
}
